export enum EFilters {
  SEARCH = "search",
  PAGE = "page",
  PER_PAGE = "per_page",
}
